/** 案件 条件相談：ステータス デフォルト */
export const RFP_NEGOTIATE_STATUS_DEFAULT = {
    clientLabel: '',
    label: '',
    professionalLabel: '',
    value: 'default',
};
/** 案件 条件相談：ステータス 送信済 */
export const RFP_NEGOTIATE_STATUS_SENT = {
    clientLabel: '返信済',
    label: '返信済',
    professionalLabel: '返信待ち',
    value: 'sent',
};
/** 案件 条件相談：ステータス 受信 */
export const RFP_NEGOTIATE_STATUS_RECEIVED = {
    clientLabel: '未返信',
    label: '未返信',
    professionalLabel: '返信あり',
    value: 'received',
};
/** 案件 条件相談：ステータスの一覧 */
export const RFP_NEGOTIATE_STATUSES = [
    RFP_NEGOTIATE_STATUS_DEFAULT,
    RFP_NEGOTIATE_STATUS_SENT,
    RFP_NEGOTIATE_STATUS_RECEIVED,
];
